import React, { useState, useEffect} from "react";
import axios from "axios";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { useNavigate } from 'react-router-dom';

const Expense = () => {
    const navigate = useNavigate();
	const [expenses, setExpenses] = useState([]);
    const [formData, setFormData] = useState({
        category: '',
        amount: '',
        date: '',
        description: '',

    });

    // Fetching Data
    useEffect(() => {
        axios.get("https://api.trucoo.in/payment/allexpense")
            .then(response => {
                setExpenses(response.data)
				console.log("Form Submitted: ", response.data);
            })
            .catch(error => {
                console.error("There was an error in Fecthing Data", error)
            })
    }, []);
    console.log(expenses);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        

        console.log("Form Submitted: ", formData);

        // Fetch functionality
        axios.post('https://api.trucoo.in/payment/allexpense/', formData, {

            headers: {
                'Content-Type': 'application/json'
            }

        })
            .then(response => {
                if (response.data.status === "success") {
                       navigate(`/expense`);
                  } else {
                    console.error(response.data);
                  }

            })
            .catch(error => {
                console.error("There was an Error");
            });

        console.log('Form Data:', formData);

    }
    return(

        <>
        <Header />
        <Sidebar />


        <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					<div class="row">
                       
					<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
							    <div class="box-body">

								    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>Expenses</h4>
								    <hr class="my-15" />

								    <div class="row">

										{/* category*/}
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Category</label>
									            <input type="text" class="form-control" name="category" value={formData.category} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the category */}

										{/* date */}
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Date</label>
									            <input type="date" class="form-control" name="date" value={formData.date} onChange={handleChange}/>
									        </div>
								        </div>

										{/* end of the date*/}

										{/* amount */}
										<div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Amount</label>
									            <input type="number" class="form-control" name="amount" value={formData.amount} onChange={handleChange} />
											
									        </div>
								        </div>
										{/* end of the amount */}


                                        {/* description */}
                                        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Description</label>
                                                <textarea rows="2" class="form-control" name="description" value={formData.description} onChange={handleChange}></textarea>
									        </div>
								        </div>
                                        {/* description end */}

								    </div>
                        
                                </div>
                            </div>
                        </div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
							        <div class="box-footer" align="center">
								        <button type="button" class="btn btn-primary-light me-1"><i class="ti-trash"></i> Cancel</button>
								        <button type="submit" class="btn btn-primary" onClick={handleSubmit}><i class="ti-save-alt"></i> Save</button>
										    </div>  
						
					            </div>
						    </div>
						</div>
                     
					</div>
				</div>
			</section>
		</div>
	</div>


        </>
    )

    
}

export default Expense;